<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  // import stuList from './components/org_list.vue'
  export default {
    name: 'app',
    components: {},
	 mounted() {
	    // 正确的生命周期钩子 - 组件挂载后执行
	    let token = window.localStorage.getItem("tea_token")
	    if (!token) {
	      // 使用Vue Router进行导航，而不是直接修改window.location
	      this.$router.push('/')
	    }
	  }
  }
</script>
